import { render, staticRenderFns } from "./StoryTable.vue?vue&type=template&id=74d30457&scoped=true&"
import script from "./StoryTable.vue?vue&type=script&lang=js&"
export * from "./StoryTable.vue?vue&type=script&lang=js&"
import style0 from "./StoryTable.vue?vue&type=style&index=0&id=74d30457&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d30457",
  null
  
)

export default component.exports